module.exports = __webpack_public_path__ + "static/media/chat_background.24acc504.png";